import { makeStyles } from '@material-ui/core/styles'
import AccountAvatar from './AccountAvatar'
import { Text } from '../../../1elements'
import { useEffect, useState } from 'react'
import { useSelector } from '../../../../common/redux.Interface.Component'

const AccountDetailView = ({ className }) => {
  const accountDetail = useSelector(state => state.tabs.accountDetail)
  const location = useSelector(state => state.tabs.location)

  const classes = useStyles()
  const [accountName, setAccountName] = useState('')
  const [address, setAddress] = useState({
    street: '',
    city: '',
    province: '',
    postalCode: '',
    country: '',
    phoneNumber: ''
  })

  useEffect(() => {
    setAccountName(accountDetail.name)
    const {
      address: street,
      city,
      state: province,
      country,
      zip_code: postalCode,
      phoneNumber
    } = location
    setAddress({ street, city, province, country, postalCode, phoneNumber })
  }, [accountDetail, location])

  return (
    <div className={`${classes.root} ${className}`}>
      <AccountAvatar accountName={accountName} />
      <div className={classes.dataDiv}>
        <Text type={'h10'} className={classes.accountName}>
          {accountName}
        </Text>
        <Text type={'p'}>
          <b>Address</b>: {address.street}
        </Text>
        <Text type={'p'}>
          <b>City</b>: {address.city}
        </Text>
        <Text type={'p'}>
          <b>Province</b>: {address.province}
        </Text>
        <Text type={'p'}>
          <b>Postal Code</b>: {address.postalCode}
        </Text>
        <Text type={'p'}>
          <b>Country</b>: {address.country}
        </Text>
        <Text type={'p'}>
          <b>Phone Number:</b> {address.phoneNumber}{' '}
        </Text>
      </div>
    </div>
  )
}

export default AccountDetailView

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    gridColumn: 'span 4',
    gridRow: 'span 4',
    display: 'flex',
    alignItems: 'center'
  },
  dataDiv: {
    marginLeft: 20
  },
  accountName: {
    color: theme.palette.primary.accent
  }
}))
